<template>
  <confirm-dialog
    :show="show"
    :message="message"
    @accept="changeStatus"
    @close="$emit('close')">
  </confirm-dialog>
</template>
 
<script>
import ConfirmDialog from '@/components/global/ConfirmDialog';

export default {
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    workflow: {
      type: Object,
      required: true,
    },
  },
  components: {
    ConfirmDialog,
  },
  computed: {
    message() {
      return `¿Esta seguro de que desea ${this.workflow.status === 'Activo' ? 'desactivar' : 'activar'} el flujo ${this.workflow.name}? Esto afectará todas las etapas y filtros asociados.`;
    },
  },
  methods: {
    changeStatus() {
      this.axios.patch(`workflows/${this.workflow.id}`, {
        status: this.workflow.status === 'Activo' ? 'Inactivo' : 'Activo',
      }).then((response) => {
        this.$emit('updated', response.data);
        this.$emit('close');
      }).catch(() => {});
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/CollectWorkflows/ChangeStatus.vue